import React from 'react';

// Recursive hierarchy node — kept in its own file so babel doesn't blow the stack
// when traversing the larger HRReportsSubtabs file.
function HierNode(props) {
  const { node } = props;
  const hasChildren = node.children && node.children.length > 0;
  return (
    <div className="flex flex-col items-center">
      <div
        className="px-4 py-2 rounded-lg shadow text-white text-center min-w-[160px]"
        style={{ backgroundColor: node.color }}
      >
        <div className="font-bold text-xs">{node.name}</div>
        <div className="text-[10px] opacity-90">{node.role}</div>
      </div>
      {hasChildren && (
        <>
          <div className="w-0.5 h-6 bg-stone-400" />
          <div className="flex gap-4 flex-wrap justify-center pt-1 border-t-2 border-stone-300 px-4">
            {node.children.map(function renderChild(c, i) {
              return (
                <div key={i} className="pt-4">
                  <HierNode node={c} />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default HierNode;
